import React, { useState, useEffect } from 'react'
import { 
  ArrowLeft,
  Save,
  RotateCcw
} from 'lucide-react'
import { Breadcrumb } from '../../components/Common'
import { useNavigate, useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import paymentTermsMasterService from '../../services/paymentTermsMasterService'

const PaymentTermsMasterEdit = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const paymentTermsData = location.state?.paymentTermsData || {}

  const [formData, setFormData] = useState({
    paymentTermsCode: '',
    order: '',
    description: '',
    status: 'Active'
  })

  // Pre-fill form data when component mounts
  useEffect(() => {
    setFormData({
      paymentTermsCode: paymentTermsData.paymentTermsCode || '',
      order: paymentTermsData.order || '',
      description: paymentTermsData.description || '',
      status: paymentTermsData.status || 'Active'
    })
  }, [paymentTermsData])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSave = async () => {
    try {
      console.log('Updating Payment Terms Master data:', formData)
      
      // Call the payment terms master API to update the data
      const updateResponse = await paymentTermsMasterService.updatePaymentTerms(paymentTermsData._id, formData)
      
      if (updateResponse && updateResponse.success) {
        toast.success('Payment Terms Master updated successfully!')
        navigate('/sales/payment-terms-master')
      } else {
        toast.error(updateResponse?.message || 'Failed to update Payment Terms Master')
      }
    } catch (error) {
      console.error('Error updating Payment Terms Master:', error)
      if (error.response?.status === 400) {
        toast.error(error.response.data?.message || 'Invalid data provided')
      } else if (error.response?.status === 401) {
        toast.error('Authentication required. Please log in again.')
        navigate('/login')
      } else if (error.response?.status === 404) {
        toast.error('Payment Terms Master not found')
      } else {
        toast.error('Failed to update Payment Terms Master')
      }
    }
  }

  const handleReset = () => {
    setFormData({
      paymentTermsCode: paymentTermsData.paymentTermsCode || '',
      order: paymentTermsData.order || '',
      description: paymentTermsData.description || '',
      status: paymentTermsData.status || 'Active'
    })
  }

  const handleBack = () => {
    navigate('/sales/payment-terms-master')
  }

  // Breadcrumb items
  const breadcrumbItems = [
    {
      label: 'Sales',
      path: '/sales',
      onClick: () => navigate('/sales')
    },
    {
      label: 'Masters',
      path: '/sales',
      onClick: () => navigate('/sales')
    },
    {
      label: 'Payment Terms Master',
      path: '/sales/payment-terms-master',
      isCurrent: true
    }
  ]

  return (
    <div className="sales-dashboard">
      {/* Breadcrumb Navigation */}
      <div className="breadcrumb-section">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      {/* Page Header */}
      <div className="page-header">
        <div className="page-title">
          <h1>Payment Terms Master - Edit</h1>
          <p>Edit payment terms master data</p>
        </div>
      </div>

      {/* Form Section */}
      <div className="form-container">
        <div className="sac-form-header">
          <h2>Payment Terms Master</h2>
        </div>
          
        <form className="form-content">
          {/* Row 1: Payment Terms Code, Order, Description, Status */}
          <div className="grid-row-4">
            <div className="form-group">
              <label htmlFor="paymentTermsCode" className="form-label required">
                Payment Terms Code
              </label>
              <input
                type="text"
                id="paymentTermsCode"
                name="paymentTermsCode"
                value={formData.paymentTermsCode}
                onChange={handleInputChange}
                className="form-input"
                placeholder="Enter payment terms code"
              />
            </div>

            <div className="form-group">
              <label htmlFor="order" className="form-label required">
                Order
              </label>
              <input
                type="number"
                id="order"
                name="order"
                value={formData.order}
                onChange={handleInputChange}
                className="form-input"
                placeholder="Enter order number"
                min="1"
                step="1"
              />
            </div>

            <div className="form-group">
              <label htmlFor="description" className="form-label required">
                Description
              </label>
              <input
                type="text"
                id="description"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                className="form-input"
                placeholder="Enter description"
              />
            </div>

            <div className="form-group">
              <label htmlFor="status" className="form-label required">
                Status
              </label>
              <select
                id="status"
                name="status"
                value={formData.status}
                onChange={handleInputChange}
                className="form-input"
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="form-actions">
            <button
              type="button"
              onClick={handleReset}
              className="btn-secondary"
            >
              <RotateCcw size={16} />
              Reset
            </button>
            <button
              type="button"
              onClick={handleSave}
              className="btn-primary"
            >
              <Save size={16} />
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default PaymentTermsMasterEdit